export default __webpack_public_path__ + "static/media/TH-55JX600 3.2389f957.jpg";